import { render, staticRenderFns } from "./ClientGeneralDataForm.vue?vue&type=template&id=71963c3d&"
import script from "./ClientGeneralDataForm.vue?vue&type=script&lang=ts&"
export * from "./ClientGeneralDataForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports